import { ISvgProps } from '@src/types';

const StickyNote = ({ width = '22px', height = '22px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icon/-Notes/-Regular" fill={fillColor} fillRule="nonzero">
          <path
            d="M3.14285714,2.35714286 C2.71071429,2.35714286 2.35714286,2.71071429 2.35714286,3.14285714 L2.35714286,18.8571429 C2.35714286,19.2892857 2.71071429,19.6428571 3.14285714,19.6428571 L14.1428571,19.6428571 L14.1428571,15.7142857 C14.1428571,14.8450893 14.8450893,14.1428571 15.7142857,14.1428571 L19.6428571,14.1428571 L19.6428571,3.14285714 C19.6428571,2.71071429 19.2892857,2.35714286 18.8571429,2.35714286 L3.14285714,2.35714286 Z M14.1428571,22 L3.14285714,22 C1.409375,22 0,20.590625 0,18.8571429 L0,3.14285714 C0,1.409375 1.409375,0 3.14285714,0 L18.8571429,0 C20.590625,0 22,1.409375 22,3.14285714 L22,14.1428571 L22,14.4129464 C22,15.2477679 21.6709821,16.0482143 21.0816964,16.6375 L16.6375,21.0816964 C16.0482143,21.6709821 15.2477679,22 14.4129464,22 L14.1428571,22 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default StickyNote;
